import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.set";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";

/*!
 * Antd Utils v0.1.13
 * author Tony.Xu
 * utils for Ant Design
 */

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */
var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) {
        d[p] = b[p];
      }
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    var arguments$1 = arguments;

    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments$1[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) {
          t[p] = s[p];
        }
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) {
      t[p] = s[p];
    }
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") {
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) {
        t[p[i]] = s[p[i]];
      }
    }
  }

  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;

  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") {
    r = Reflect.decorate(decorators, target, key, desc);
  } else {
    for (var i = decorators.length - 1; i >= 0; i--) {
      if (d = decorators[i]) {
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      }
    }
  }

  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
}

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") {
    return Reflect.metadata(metadataKey, metadataValue);
  }
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) {
        throw t[1];
      }

      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) {
      throw new TypeError("Generator is already executing.");
    }

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) {
          return t;
        }

        if (y = 0, t) {
          op = [op[0] & 2, t.value];
        }

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) {
              _.ops.pop();
            }

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) {
      throw op[1];
    }

    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

function __createBinding(o, m, k, k2) {
  if (k2 === undefined) {
    k2 = k;
  }

  o[k2] = m[k];
}

function __exportStar(m, exports) {
  for (var p in m) {
    if (p !== "default" && !exports.hasOwnProperty(p)) {
      exports[p] = m[p];
    }
  }
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;

  if (m) {
    return m.call(o);
  }

  if (o && typeof o.length === "number") {
    return {
      next: function next() {
        if (o && i >= o.length) {
          o = void 0;
        }

        return {
          value: o && o[i++],
          done: !o
        };
      }
    };
  }

  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];

  if (!m) {
    return o;
  }

  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) {
        m.call(i);
      }
    } finally {
      if (e) {
        throw e.error;
      }
    }
  }

  return ar;
}

function __spread() {
  var arguments$1 = arguments;

  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments$1[i]));
  }

  return ar;
}

function __spreadArrays() {
  var arguments$1 = arguments;

  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments$1[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) {
    throw new TypeError("Symbol.asyncIterator is not defined.");
  }

  var g = generator.apply(thisArg, _arguments || []),
      i,
      q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i;

  function verb(n) {
    if (g[n]) {
      i[n] = function (v) {
        return new Promise(function (a, b) {
          q.push([n, v, a, b]) > 1 || resume(n, v);
        });
      };
    }
  }

  function resume(n, v) {
    try {
      step(g[n](v));
    } catch (e) {
      settle(q[0][3], e);
    }
  }

  function step(r) {
    r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
  }

  function fulfill(value) {
    resume("next", value);
  }

  function reject(value) {
    resume("throw", value);
  }

  function settle(f, v) {
    if (f(v), q.shift(), q.length) {
      resume(q[0][0], q[0][1]);
    }
  }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) {
    throw e;
  }), verb("return"), i[Symbol.iterator] = function () {
    return this;
  }, i;

  function verb(n, f) {
    i[n] = o[n] ? function (v) {
      return (p = !p) ? {
        value: __await(o[n](v)),
        done: n === "return"
      } : f ? f(v) : v;
    } : f;
  }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) {
    throw new TypeError("Symbol.asyncIterator is not defined.");
  }

  var m = o[Symbol.asyncIterator],
      i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i);

  function verb(n) {
    i[n] = o[n] && function (v) {
      return new Promise(function (resolve, reject) {
        v = o[n](v), settle(resolve, reject, v.done, v.value);
      });
    };
  }

  function settle(resolve, reject, d, v) {
    Promise.resolve(v).then(function (v) {
      resolve({
        value: v,
        done: d
      });
    }, reject);
  }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
}

function __importStar(mod) {
  if (mod && mod.__esModule) {
    return mod;
  }

  var result = {};

  if (mod != null) {
    for (var k in mod) {
      if (Object.hasOwnProperty.call(mod, k)) {
        result[k] = mod[k];
      }
    }
  }

  result["default"] = mod;
  return result;
}

function __importDefault(mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
}

function __classPrivateFieldGet(receiver, privateMap) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }

  return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to set private field on non-instance");
  }

  privateMap.set(receiver, value);
  return value;
}

var tslib_es6 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  __extends: __extends,

  get __assign() {
    return _assign;
  },

  __rest: __rest,
  __decorate: __decorate,
  __param: __param,
  __metadata: __metadata,
  __awaiter: __awaiter,
  __generator: __generator,
  __createBinding: __createBinding,
  __exportStar: __exportStar,
  __values: __values,
  __read: __read,
  __spread: __spread,
  __spreadArrays: __spreadArrays,
  __await: __await,
  __asyncGenerator: __asyncGenerator,
  __asyncDelegator: __asyncDelegator,
  __asyncValues: __asyncValues,
  __makeTemplateObject: __makeTemplateObject,
  __importStar: __importStar,
  __importDefault: __importDefault,
  __classPrivateFieldGet: __classPrivateFieldGet,
  __classPrivateFieldSet: __classPrivateFieldSet
});

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var transformTable_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function transformTable(oldColumns, oldData, options) {
    if (!oldData || !oldData.length) {
      return {
        newColumns: [],
        newData: []
      };
    }

    var newColumns = tslib_es6.__spread([{
      title: 'title',
      dataIndex: 'title',
      fixed: 'left',
      width: 150
    }], oldData.map(function (item, index) {
      return {
        dataIndex: index,
        width: '100%'
      };
    }));

    var newData = oldColumns.map(function (column, index) {
      return tslib_es6.__assign({
        title: oldColumns[index].title
      }, Object.entries(oldData || []).map(function (item, i) {
        var _a;

        var value = column.dataIndex && item[1] ? item[1][column.dataIndex] : undefined;

        if (column.render) {
          value = column.render(item[1][column.dataIndex], oldData[i], i);
        }

        return _a = {}, _a[item[0]] = value, _a;
      }).reduce(function (prev, next) {
        return tslib_es6.__assign(tslib_es6.__assign({}, prev), next);
      }, []));
    });
    console.log('new', newColumns, newData);
    return {
      newColumns: newColumns,
      newData: newData
    };
  }

  exports["default"] = transformTable;
});
unwrapExports(transformTable_1);
var calcRowspanToMerge_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function calcRowspanToMerge(items, propName) {
    var rowSpanMapping = [];
    var saveId = -1;
    var saveIndex = 0;
    var saveCount = 0;

    for (var index = 0; index < items.length; index++) {
      var element = items[index];

      if (saveId === -1) {
        saveId = element[propName];
        saveCount = 1;
        continue;
      }

      if (saveId !== element[propName]) {
        rowSpanMapping[saveIndex] = saveCount;
        saveId = element[propName];
        saveIndex = index;
        saveCount = 1;
      } else {
        rowSpanMapping[index] = 0;
        saveCount++;
      }

      if (index === items.length - 1 && rowSpanMapping[index] === 0) {
        rowSpanMapping[saveIndex] = saveCount;
      }
    }

    return rowSpanMapping;
  }

  exports["default"] = calcRowspanToMerge;
});
unwrapExports(calcRowspanToMerge_1);

function parseTags(value, form, keyName) {
  var _a;

  if (value && value.length) {
    var parsedValue_1 = [];
    value.map(function (item) {
      if (item.includes(',')) {
        parsedValue_1 = tslib_es6.__spread(parsedValue_1, item.split(',').filter(function (item) {
          return item !== '';
        }));
      } else {
        parsedValue_1.push(item);
      }
    });
    form.setFieldsValue((_a = {}, _a[keyName] = Array.from(new Set(parsedValue_1)), _a));
    form.validateFields([keyName]);
  }
}

var pasteTags = parseTags;

function enum2Options(enumObj, labelName, valueName) {
  if (labelName === void 0) {
    labelName = 'label';
  }

  if (valueName === void 0) {
    valueName = 'value';
  }

  if (!enumObj) {
    return [];
  }

  return (Object.keys(enumObj).filter(function (key) {
    return isNaN(Number(key));
  }) || []).map(function (key) {
    var _a;

    return _a = {}, _a[labelName] = key, _a[valueName] = enumObj[key], _a;
  });
}

var enum2options = enum2Options;
var getQuerystring = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function getQueryString(name) {
    var match = location.search.substring(1).match(new RegExp("(^|&)" + name + "=([^$&]*)(&|$)", 'i'));

    if (match !== null) {
      return unescape(match[2]);
    }

    return null;
  }

  exports["default"] = getQueryString;
});
unwrapExports(getQuerystring);
var handleVisibilityChange_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function handleVisibilityChange(pageShowCallback, pageHideCallback) {
    try {
      var hiddenHandler = function hiddenHandler() {
        var isHidden = document.hidden;

        if (!isHidden) {
          pageShowCallback && pageShowCallback();
        } else {
          pageHideCallback && pageHideCallback();
        }
      };

      document.onvisibilitychange = hiddenHandler;
    } catch (error) {
      console.warn(error);
    }
  }

  exports["default"] = handleVisibilityChange;
});
unwrapExports(handleVisibilityChange_1);

var transform_table_1 = tslib_es6.__importDefault(transformTable_1);

var calc_rowspan_to_merge_1 = tslib_es6.__importDefault(calcRowspanToMerge_1);

var paste_tags_1 = tslib_es6.__importDefault(pasteTags);

var enum2options_1 = tslib_es6.__importDefault(enum2options);

var get_querystring_1 = tslib_es6.__importDefault(getQuerystring);

var handle_visibility_change_1 = tslib_es6.__importDefault(handleVisibilityChange_1);

var entryCompiler = {
  transformTable: transform_table_1["default"],
  calcRowspanToMerge: calc_rowspan_to_merge_1["default"],
  pasteTags: paste_tags_1["default"],
  enum2Options: enum2options_1["default"],
  getQueryString: get_querystring_1["default"],
  handleVisibilityChange: handle_visibility_change_1["default"]
};
var entryCompiler_1 = entryCompiler.transformTable;
var entryCompiler_2 = entryCompiler.calcRowspanToMerge;
var entryCompiler_3 = entryCompiler.pasteTags;
var entryCompiler_4 = entryCompiler.enum2Options;
var entryCompiler_5 = entryCompiler.getQueryString;
var entryCompiler_6 = entryCompiler.handleVisibilityChange;
export default entryCompiler;
export { entryCompiler_2 as calcRowspanToMerge, entryCompiler_4 as enum2Options, entryCompiler_5 as getQueryString, entryCompiler_6 as handleVisibilityChange, entryCompiler_3 as pasteTags, entryCompiler_1 as transformTable };